import React, { useState, useEffect } from "react";
import axios from "axios";

function InsuranceConditions() {
  const [content, setContent] = useState({ text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(
          "/api/information/public/insuranceConditions"
        );
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching insurance conditions content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="pt-[60px] px-4 max-w-4xl mx-auto text-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="pt-[60px] px-4 max-w-4xl mx-auto">
      <h1 className="text-3xl mb-6">Insurance Conditions</h1>
      <div className="prose max-w-none">
        <div className="whitespace-pre-wrap text-gray-700 leading-relaxed">
          {content.text || "Content coming soon..."}
        </div>
      </div>
    </div>
  );
}

export default InsuranceConditions;
